/**
 * Animate background gradient by tracking mouse position
 * https://blog.prototypr.io/stunning-hover-effects-with-css-variables-f855e7b95330
 */

function relativeOffset(container: HTMLElement, event: MouseEvent): { x: number, y: number } {
  const offset = { x: event.offsetX, y: event.offsetY };

  for (let el = event.target; el instanceof HTMLElement && el !== container; el = el.offsetParent) {
    offset.x += el.offsetLeft;
    offset.y += el.offsetTop;
  }

  return offset;
}

export default function animateBackground(element: HTMLElement, props: {}) {
  function mouseMove(event: MouseEvent) {
    event.stopPropagation();

    const pos = relativeOffset(element, event);
    element.style.setProperty("--x", `${pos.x}px`);
    element.style.setProperty("--y", `${pos.y}px`);
  }

  function updateEvent() {
    if (query.matches) {
      element.addEventListener("mousemove", mouseMove);
    } else {
      element.removeEventListener("mousemove", mouseMove);
    }
  }

  const query = window.matchMedia("(min-width: 1024px)");
  query.addEventListener("change", updateEvent);
  updateEvent();
}
